module.exports = __webpack_public_path__ + "img/2.552547e9.png";